import { gql } from "@apollo/client";

export const GET_DOCUMENTOS_RI = gql`
query GetDocumentosRI($idDatosGeneralesRI: Int!) {
    documentosRI(idDatosGeneralesRI: $idDatosGeneralesRI) {
      success,
      error,
      valorEsperado {
        idTipoDocumentoRI,
        idDatosGeneralesRI,
        archivo,
        extension,
        contentType,
        titulo,
        tipoDocumento
      }
    }
  }`;